import type { ProposalNodeSet } from '../types';

export type StructureRef = { id: string; name: string };

export function enabledProposalStructures(nodeSets: ProposalNodeSet[] | undefined | null): StructureRef[] {
  if (!nodeSets?.length) return [];
  return nodeSets
    .filter((ns) => ns.enabled !== false)
    .map((ns) => ({ id: ns.id, name: ns.name }));
}
